import { DASHBOARD_URLS, PAGE_URLS } from '$training-portal/constants';

export const getRedirectUrl = (user: any) => {
  if (user && user.roles && user.roles.length) {
    for (const role of user.roles) {
      switch (role) {
        case 'trainer':
          return DASHBOARD_URLS.trainer;
        case 'trainee':
          return DASHBOARD_URLS.trainee;
      }
    }
  }

  return PAGE_URLS.ssoLoginUrl;
};
